import PropTypes from 'prop-types';
import React from 'react';

import {
    formatCalendarListingItemTime,
    getPrettyItemTypeName
} from '$utilities/format';

import { TagCloudSmall } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselItemCalendarDetailPage = ({
    __typename = null,
    carouselItemIndex = null,
    endDate = null,
    listingImage = null,
    listingText = null,
    location = null,
    startDate = null,
    tags = null,
    title = null,
    url = null
}) => {
    return (
        <>
            {carouselItemIndex === 0 && (
                <div className='hidden md:block md:w-1/5 layout-grid-col-padding'/>
            )}

            <div className={`-ml-15 expand-interaction focus-within:bg-peach hover:bg-peach p-30${carouselItemIndex === 0 ? ' w-12/12 md:w-4/5' : ' w-12/12'}`}>
                <div className='pr-35'>
                    <a
                        className='flex flex-col'
                        href={url}>
                        {(__typename) && (
                            <p className='type-style-4'>
                                {getPrettyItemTypeName(__typename)}
                            </p>
                        )}

                        <div className='flow-root mt-30'>
                            {/* image */}
                            {listingImage && (
                                <img
                                    alt={listingImage.alt}
                                    className='w-3/12 sm:w-2/12 float-left object-cover aspect-square mr-10 pointer-events-none'
                                    height={listingImage.height}
                                    loading='lazy'
                                    src={listingImage.px2}
                                    width={listingImage.width} />
                            )}

                            {(listingText || title) && (
                                <p className='type-style-3 mt-15'>
                                    {listingText || title}
                                </p>
                            )}
                        </div>

                        {location && (
                            <p className='type-style-4 mt-30'>
                                {location}
                            </p>
                        )}

                        <p
                            className='type-style-4 mt-20'
                            dangerouslySetInnerHTML={{ __html: formatCalendarListingItemTime(__typename, startDate, endDate) }} />
                    </a>

                    {tags.length > 0 && (
                        <div className='mt-40 md:mt-40 pr-25 md:pr-50'>
                            <TagCloudSmall tags={tags} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemCalendarDetailPage.propTypes = {
    __typename: PropTypes.string.isRequired,
    carouselItemIndex: PropTypes.number.isRequired,
    endDate: PropTypes.string.isRequired,
    listingImage: PropTypes.object,
    listingText: PropTypes.string,
    location: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default CarouselItemCalendarDetailPage;
